/* © ИП Коробкин И.Н., KIN DIGITAL CRM+ */
export const PARTY_KIND_LABEL: Record<string, string> = { LEGAL: 'Юрлицо', IP: 'ИП', PERSON: 'Физлицо' };
export const RELATION_LABEL: Record<string, string> = {
  DIRECTOR: 'Руководитель', FOUNDER: 'Учредитель', GUARANTOR: 'Поручитель', SPOUSE: 'Супруг(а)',
  REPRESENTATIVE: 'Представитель', EMPLOYEE: 'Сотрудник', OTHER: 'Иное',
};
export const CONTRACT_STATUS_LABEL: Record<string, string> = {
  DRAFT: 'Черновик', APPROVAL: 'Согласование', ACTIVE: 'Действует', CLOSED: 'Исполнен', TERMINATED: 'Расторгнут',
};
export const MATTER_KIND_LABEL: Record<string, string> = {
  COURT: 'Судебное дело', BANKRUPTCY: 'Банкротство', ENFORCEMENT: 'Исполнительное производство',
  COLLECTION: 'Взыскание', PROJECT: 'Проект', CONSULTING: 'Консультирование',
};
export const TASK_STATUS_LABEL: Record<string, string> = { TODO: 'К выполнению', IN_PROGRESS: 'В работе', DONE: 'Выполнена', CANCELLED: 'Отменена' };
export const EXPENSE_KIND_LABEL: Record<string, string> = { PRODUCTION: 'Производственные затраты', OVERHEAD: 'Расходы' };
